import axios from "axios";
const url = process.env.REACT_APP_HOMEPAGE;

export const AxiosConnect = axios.create({
    baseURL: "https://axgura-dashboard.uk.r.appspot.com" || "http://localhost:5001"
});